import React from 'react';
import { createPortal } from 'react-dom';
import { VIEW_ICONS } from '../icons';

/**
 * ViewMenu - Dropdown menu for selecting which view to open item in
 */
const ViewMenu = ({ 
  views, 
  position, 
  onSelectView,
  onStopPropagation 
}) => {
  const hasCustomViews = views.some(v => !v.isDefault);
  
  return createPortal(
    <div 
      className="unified-search-popup__view-menu"
      style={{ top: position.top, left: position.left, width: position.width }}
      onClick={onStopPropagation}
    >
      <div className="unified-search-popup__view-menu-header">Open in…</div>
      <div className="unified-search-popup__view-menu-section">
        {views.filter(v => v.isDefault).map(view => {
          const ViewIcon = VIEW_ICONS[view.type];
          return (
            <button 
              key={view.id}
              className="unified-search-popup__view-menu-item"
              onClick={() => onSelectView(view)}
            >
              {ViewIcon && <ViewIcon size={12} />}
              <span>{view.name}</span>
            </button>
          );
        })}
      </div>
      {hasCustomViews && (
        <>
          <div className="unified-search-popup__view-menu-divider" />
          <div className="unified-search-popup__view-menu-section">
            <div className="unified-search-popup__view-menu-subheader">Custom Views</div>
            {views.filter(v => !v.isDefault).map(view => {
              const ViewIcon = VIEW_ICONS[view.type];
              return (
                <button 
                  key={view.id}
                  className="unified-search-popup__view-menu-item"
                  onClick={() => onSelectView(view)}
                >
                  {ViewIcon && <ViewIcon size={12} />}
                  <span>{view.name}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>,
    document.body
  );
};

export default ViewMenu;
